import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//退票，列表查询
export function getRefundListPage(obj) {
  return request({
    url: urlPrefix +'/refund/refundlistpage',
    method:'post',
    data:obj
  })
}


//退票数据导出
export function exportRefundDetail(obj){
  return request({
    url: urlPrefix+'/refund/exportRefundDetail',
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}




export function updateBankInfo(obj) {
  return request({
    url: urlPrefix +'/refund/updateBankInfo',
    method:'post',
    data:obj
  })
}
export function createPayoutBill(obj) {
  return request({
    url: urlPrefix +'/payout/saveRefundPayOutBill',
    method:'post',
    data:obj
  })
}
//退票编辑页面回显值
export function getRefundEditValue(obj) {
  return request({
    url: urlPrefix +'/refund/getrefundbyid',
    method:'get',
    params:obj
  })
}

//退票中在途列表数据
export function getOnTheWayRecords(obj) {
  return request({
    url: urlPrefix +`/base-data/on-the-way`,
    method:'post',
    data:obj
  })
}
//更新操作模式信息
export function  updateBankInfoHandle(obj) {
  return request({
    url: urlPrefix + '/base-data/updateOnTheWayBankInfo',
    method: 'post',
    data:obj
  })
}
//更新操作模式信息
export function  updateBankInfoAuto(obj) {
  return request({
    url: urlPrefix + '/base-data/updateOnTheWayBankInfoAuto',
    method: 'post',
    data:obj
  })
}
//更新已退票的记录信息
export function updateRefundInfo(obj) {
  return request({
    url: urlPrefix +'/refund/updaterefundinfo',
    method:'put',
    data:obj
  })
}




